export default __webpack_public_path__ + "static/media/TorqueImg.dc68d122.jpg";